export const CREATE_ERROR = 'CREATE_ERROR';
export const DELETE_ERROR = 'DELETE_ERROR';
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
export const SET_ERRORS_AS_SHOWN = 'SET_ERRORS_AS_SHOWN';
export const REMOVE_FIRST_SHOWN_ERROR = 'REMOVE_FIRST_SHOWN_ERROR';
